export default {
    character: 'Caractere',
    characters: 'Caracteres',
    remaining: 'Restante',
    optional: '(opcional)',
    required: '(necessario)',
};
